import { render, staticRenderFns } from "./ProductInfoItemName.vue?vue&type=template&id=bbe23360&scoped=true&"
import script from "./ProductInfoItemName.vue?vue&type=script&lang=js&"
export * from "./ProductInfoItemName.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoItemName.vue?vue&type=style&index=0&id=bbe23360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe23360",
  null
  
)

export default component.exports